import { downloadAllocationRules } from 'src/api/CarrierPartner';
import { getBookingMastersTableData } from '../../api/BookingMasters';

const BUCKET_TO_PERM = {
  tat: 'tat',
  serviceability: 'serviceability',
  destinationType: 'destination',
  holidayv2: 'holidayv2',
};

const checkPermissions = (masterData, bucket, action = 'update') => {
  const permBucket = BUCKET_TO_PERM[bucket];
  if (!permBucket) return true;
  return masterData.ops_dashboard_config?.parts_to_show
    ?.setup_permission_obj?.booking_master_v2?.[permBucket]?.[action];
};

const viewControl = {
  pageTitle: 'Setup',
  buckets: ['serviceability', 'destinationType', 'tat', 'holidayv2'],
  globalActions: [],
  fetchData: getBookingMastersTableData,
  downloadData: downloadAllocationRules,
  redirectToMiddleMileDownloads: true,
  conditionalAsyncDownload: true,
  filters: [],
  actions: [
    {
      key: 'update',
      name: 'Update',
      isAllowed: (masterData, bucket) => checkPermissions(masterData, bucket, 'update'),
    },
    {
      key: 'add',
      name: 'Add New',
      isAllowed: (masterData, bucket) => checkPermissions(masterData, bucket, 'create'),
    },
    {
      key: 'pagination',
      name: 'Pagination',
    },
    {
      key: 'download',
      name: 'Download',
    },
    {
      key: 'reload',
      name: 'Reload',
    },
  ],
};
const buckets = {
  serviceability: {
    name: 'Serviceability Master',
    filters: [],
    actions: [],
  },
  destinationType: {
    name: 'Destination Type Master',
    filters: [],
    actions: [],
  },
  tat: {
    name: 'TAT Master',
    filters: [],
    actions: [],
  },
  holidayv2: {
    name: 'Holiday Master',
    filters: [],
    actions: [],
  },
};

const bucketColor = {};

export default { viewControl, buckets, bucketColor };
